import { render, staticRenderFns } from "./story-compare.vue?vue&type=template&id=7560ad1f&"
import script from "./story-compare.vue?vue&type=script&lang=js&"
export * from "./story-compare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports